import { MenuList } from '@mui/material';
import { ReactNode } from 'react';

export type MenuProps = {
  children: ReactNode;
};

export const Menu = ({ children }: MenuProps) => {
  return (
    <MenuList
      sx={{
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        minWidth: 150,
      }}
    >
      {children}
    </MenuList>
  );
};
